<template>
  <div>
    <LoadingSpinner :loading="isLoading" />
    <div v-if="!isLoading">
      <TicketInfoBox :item="item" />
      <NewChatBox :item="item" />
      <SendMessage
        v-if="!isFinishedTicket"
        :id="code"
        accessLevel="admin"
        @getData="fetchData"
      />
      <TicketModalButtons
        v-if="!isFinishedTicket"
        :id="code"
        :item="item"
        @getData="fetchData"
      />
    </div>
  </div>
</template>

<script>
import TicketInfoBox from "../components/TicketInfoBox";
import NewChatBox from "../components/NewChatBox";
import SendMessage from "../components/SendMessage";
import TicketModalButtons from "../components/TicketModalButtons";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  name: "new-edit-all-ticket",
  inject: ["allticketRepository"],
  components: {
    NewChatBox,
    LoadingSpinner,
    SendMessage,
    TicketInfoBox,
    TicketModalButtons,
  },
  data() {
    return {
      code: this.$route.params.code,
      item: null,
      isLoading: false,
    };
  },
  computed: {
    isFinishedTicket() {
      return pathOr(false, ["ticket_finished"], this.item);
    },
  },
  methods: {
    pathOr,
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.allticketRepository.find(this.code);
        this.item = pathOr(null, ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
